const REQUEST_COMPONENT_SEASONS = '@@teams/REQUEST_COMPONENT_SEASONS';
const COMPONENT_SEASONS_RESPONSE = '@@teams/COMPONENT_SEASONS_RESPONSE';

export default {
    REQUEST_COMPONENT_SEASONS,
    COMPONENT_SEASONS_RESPONSE
};